import { Container } from "react-bootstrap";
import { PostCard } from "./PostCard";
import blogsData from "../data/blogs.json";
import { getImageByKey } from "../data/imageMap";
import "animate.css";
import TrackVisibility from "react-on-screen";

export const Blogs = () => {
  const posts = blogsData.map((post) => ({
    ...post,
    imgUrl: getImageByKey(post.imageKey),
  }));
  // duplicated once so the marquee track can loop seamlessly at -50%
  const trackPosts = [...posts, ...posts];

  return (
    <section className="blogs" id="blogs">
      <Container>
        <TrackVisibility once>
          {({ isVisible }) => (
            <div className={isVisible ? "animate__animated animate__fadeIn" : ""}>
              <h2>Blogs</h2>
              <p>Notes, explainers and deep dives</p>
            </div>
          )}
        </TrackVisibility>
      </Container>
      <div className="blog-marquee">
        <div className="blog-marquee-track">
          {trackPosts.map((post, index) => (
            <PostCard key={index} {...post} />
          ))}
        </div>
      </div>
    </section>
  );
};
